import React, { Component } from 'react';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import Done from 'material-ui/svg-icons/action/done';
import Redirect from 'react-router/Redirect';

import { validateToken, joinGroup } from '../actions/actions';
import getErrors from '../modules/geterrors';

class JoinGroup extends Component {

  constructor() {
    super();

    this.state = {
      key: '',
    };
  }

  handleInput = (event) => {
    event.preventDefault();
    const key = this.tokenInput.getValue().trim();
    this.setState({ key });

    if (key.length === 10) {
      this.props.dispatch(validateToken({ key }));
    }
  }

  handleClick(event) {
    event.preventDefault();

    const validToken = this.props.validation.token.isValid;
    if (validToken) {
      this.props.dispatch(joinGroup({ key: this.state.key }));
    }
  }

  render() {
    if (this.props.auth.user.hasGroup) {
      return <Redirect to={{ pathname: '/' }} />;
    }

    const joinGroup = this.props.joinGroup;
    const token = this.props.validation.token;
    const { errorMessages } = getErrors(this.props.validation.token.errors);

    const validToken = this.props.validation.token.isValid;
    const disabled = !token.hasFetched || !validToken || joinGroup.isFetching;

    const fetchingTokenMessage = (this.props.isWaiting.VALIDATE_TOKEN) ? 'Validating token...' : '';
    let tokenError;
    let TokenButtonIcon;

    if (this.state.key.length === 10 && token.hasFetched && !token.isValid) {
      tokenError = 'Token not valid or the group is full';
    } else if (this.state.key.length === 10 && token.hasFetched && token.isValid) {
      TokenButtonIcon = <Done />;
    }

    return (
      <div className="unregistered" key="passwordforgot">
        <Card>
          <CardHeader title="Join Group" />
          <CardText>You need a registration token to join a user group. Ask your organization&apos;s administrator if you don&apos;t have one.<br /><br />
            <div className="pronounce-login">
              <form>
                <TextField autoFocus onChange={this.handleInput} ref={(input) => { this.tokenInput = input; }} errorText={tokenError} type="text" name="token" placeholder="Token" value={this.state.token} /><br />
                {fetchingTokenMessage}
                <FlatButton type="submit" disabled={disabled} icon={TokenButtonIcon} onClick={event => this.handleClick(event)} label="Join Group" />
              </form>
            </div>
          </CardText>
          <CardText>{errorMessages.map(error => <div><strong>{error}</strong></div>)}</CardText>
        </Card>
      </div>
    );
  }

}

export default JoinGroup;



// WEBPACK FOOTER //
// ./src/components/JoinGroup.js